import { PersonPreferenceViewModel } from '../../models/Entities/Person/Preference/PersonPreferenceModels';
import { CommonState } from '../common/state/commonState';

export interface PersonPreferenceState extends CommonState<PersonPreferenceViewModel> {
    lastCreated?: PersonPreferenceViewModel;
}

export const PersonPreferenceUnloadState: PersonPreferenceState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
